import React from "react";
import {twMerge} from "tailwind-merge";

export function LoadingBar(props: { className?: string }) {
    return (
        <div
            className={twMerge(
                "relative h-1 w-full overflow-hidden rounded-full",
                "bg-gray-200 dark:bg-gray-800",
                props.className
            )}
        >
            <div
                className={twMerge(
                    "absolute left-0 top-0 h-full w-1/3 rounded-full",
                    "bg-gradient-to-r from-indigo-500 via-blue-500 to-indigo-600",
                    "dark:from-indigo-300 dark:via-blue-200 dark:to-indigo-400",
                    "loading-bar-stripe"
                )}
            />
        </div>
    );
}
